module.exports = __webpack_public_path__ + "img/2.fad664dd.jpg";